// extracted by mini-css-extract-plugin
module.exports = {"content":"styles__content___1U4ye","loading":"styles__loading___2lkW2"};